import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "list-group-item d-flex justify-content-between gap-2 align-items-baseline" }
const _hoisted_2 = { class: "me-auto" }
const _hoisted_3 = ["disabled", "download", "href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.fileName) + " ", 1),
      (_ctx.persistent)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$t('review.review.entry.attachmentAt', {
            givenName: _ctx.attachment.attachmentPersonGivenName,
            surName: _ctx.attachment.attachmentPersonSurName,
            date: _ctx.$d(new Date(_ctx.attachment.attachmentCreated * 1000)),
        })), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", {
      disabled: this.disabled,
      download: _ctx.fileName,
      href: _ctx.link,
      class: "btn btn-sm btn-outline-secondary"
    }, _hoisted_5, 8, _hoisted_3),
    _createElementVNode("button", {
      "this.disabled": "this.disabled",
      type: "button",
      class: "btn btn-sm btn-outline-danger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
    }, _hoisted_7)
  ]))
}